import {Action} from '@ngrx/store';

export interface ToastsMethodCall {
  message: string;
  title?: string;
  // tslint:disable-next-line:no-any
  options?: any;
}

// tslint:disable-next-line:variable-name
export const ToastsAction = {
  ERROR: '[Toasts] Error',
  INFO: '[Toasts] Info',
  SUCCESS: '[Toasts] Success',
  WARNING: '[Toasts] Warning',
  CUSTOM: '[Toasts] Custom',
  CLEAR_ALL: '[Toasts] Clear All'
};

export class ErrorToastAction implements Action {
  readonly type = ToastsAction.ERROR;

  constructor(public payload: ToastsMethodCall) {}
}

export class InfoToastAction implements Action {
  readonly type = ToastsAction.INFO;

  constructor(public payload: ToastsMethodCall) {}
}

export class SuccessToastAction implements Action {
  readonly type = ToastsAction.SUCCESS;

  constructor(public payload: ToastsMethodCall) {}
}

export class WarningToastAction implements Action {
  readonly type = ToastsAction.WARNING;

  constructor(public payload: ToastsMethodCall) {}
}

export class CustomToastAction implements Action {
  readonly type = ToastsAction.CUSTOM;

  constructor(public payload: ToastsMethodCall) {}
}

export class ClearAllToastsAction implements Action {
  readonly type = ToastsAction.CLEAR_ALL;

  constructor() {}
}

// tslint:disable-next-line:no-any
export function error(message: string, title?: string, options?: any): ErrorToastAction {
  const payload: ToastsMethodCall = { message, title, options };
  return new ErrorToastAction(payload);
}

// tslint:disable-next-line:no-any
export function info(message: string, title?: string, options?: any): InfoToastAction {
  const payload: ToastsMethodCall = { message, title, options };
  return new InfoToastAction(payload);
}

// tslint:disable-next-line:no-any
export function success(message: string, title?: string, options?: any): SuccessToastAction {
  const payload: ToastsMethodCall = { message, title, options };
  return new SuccessToastAction(payload);
}

// tslint:disable-next-line:no-any
export function warning(message: string, title?: string, options?: any): WarningToastAction {
  const payload: ToastsMethodCall = { message, title, options };
  return new WarningToastAction(payload);
}

// tslint:disable-next-line:no-any
export function custom(message: string, title?: string, options?: any): CustomToastAction {
  const payload: ToastsMethodCall = { message, title, options };
  return new CustomToastAction(payload);
}

export function clearAll(): ClearAllToastsAction {
  return new ClearAllToastsAction();
}
